import PartyMiscService from "@/services/bytepro/partyMisc.service";

export const partyMiscApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, fileDataId) {
      return PartyMiscService.get(fileDataId).then(
        (resp) => {
          commit("dummy", "PartyMiscService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PartyMiscService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    update({ commit }, { partyMisc, fileDataId }) {
      return PartyMiscService.update(partyMisc, fileDataId).then(
        (resp) => {
          commit("dummy", "PartyMiscService.update - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PartyMiscService.update - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
